import client from "./client";

export const getPopUp = () => client.get(`/popup/main/`);
